/**
 * Utility function to format price based on value ranges
 * - If |price| < 10: show 6 decimal points
 * - If |price| < 100: show 3 decimal points
 * - If |price| >= 100: show 2 decimal points
 */
export function formatPrice(price: number): string {
  const absPrice = Math.abs(price)
  if (absPrice < 10) {
    return price.toFixed(6)
  } else if (absPrice < 100) {
    return price.toFixed(3)
  } else {
    return price.toFixed(2)
  }
}

/**
 * Get the number of decimal places based on price value
 */
export function getPrecision(price: number): number {
  const absPrice = Math.abs(price)
  if (absPrice < 10) {
    return 6
  } else if (absPrice < 100) {
    return 3
  } else {
    return 2
  }
}